import typedAction from "data/util/typedAction";
import PropTypes from "prop-types";
import {
    epIshShape,
    spIshShape,
} from "data/MergeStore";

const MergeActions = {
    // merge modal actions
    LAUNCH_DIALOG: typedAction("merge/launch-modal", {
        target: PropTypes.oneOfType([epIshShape, spIshShape]),
        title: PropTypes.string.isRequired,
        plugin: PropTypes.string.isRequired,
    }),
    SELECT_SOURCE: typedAction("merge/select-source", {
        source: PropTypes.oneOfType([epIshShape, spIshShape]),
    }),
    TOGGLE_DRAWER: "merge/toggle-drawer",
    CANCEL: "merge/cancel",
    CANCEL_FOR_SOURCE_OPTLOCK: "merge/cancel-for-source-optlock",

    // auto merge actions
    DO_MERGE: "merge/do-merge",
};

export default MergeActions;



// WEBPACK FOOTER //
// ./app/data/MergeActions.js